import * as ActionTypes from './actionTypes'

export const fetchStart = () => ({
  type: ActionTypes.FETCH_START
})
export const fetchSuccess = incidents => ({
  type: ActionTypes.FETCH_SUCCESS,
  incidents
})
export const fetchFail = () => ({
  type: ActionTypes.FETCH_FAILURE
})

export const selectIncidents = incidentIds => ({
  type: ActionTypes.SELECT_INCIDENTS,
  incidentIds
})
export const nextIncident = () => ({ type: ActionTypes.NEXT_INCIDENT })
export const prevIncident = () => ({ type: ActionTypes.PREV_INCIDENT })
export const clearSelection = () => ({ type: ActionTypes.CLEAR_SELECTION })

export const hover = incidentId => ({ type: ActionTypes.HOVER, incidentId })
export const endHover = incidentId => ({
  type: ActionTypes.END_HOVER,
  incidentId
})
